import { render, staticRenderFns } from "./PriceList.vue?vue&type=template&id=c0630f6c&scoped=true&"
import script from "./PriceList.vue?vue&type=script&lang=js&"
export * from "./PriceList.vue?vue&type=script&lang=js&"
import style0 from "./PriceList.vue?vue&type=style&index=0&id=c0630f6c&lang=scss&scoped=true&"
import style1 from "./PriceList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0630f6c",
  null
  
)

export default component.exports